module.exports = __webpack_public_path__ + "img/RegCategories.709c03ad.svg";